/* Pタグ */
import React from 'react';
import { convertLine } from '../Convert';

interface Props {
  label: string;
  color?: string;
  bold?: boolean;
  css_class?: string;
}

const Paragraph: React.FC<Props> = ({ label, color, bold, css_class }) => {
  // 太字の設定
  const bold_css = typeof bold !== 'undefined' && bold === true ? 'link-font-bold' : '';
  // 色の規定色
  if (typeof color === 'undefined') {
    color = 'text-dark';
  }

  // CSSクラスの規定値
  if (typeof css_class === 'undefined') {
    css_class = '';
  }

  //改行\nがlabelに存在する場合はエスケープを外す。
  return (
    <div className={`paragraph ${color} ${css_class} ${bold_css} bottom-border`}>
      {convertLine(label)}
    </div>
  );
};

export default Paragraph;
